<template>
    <div class="payment__status-timer">
        <transition name="fade" mode="out-in">
            <template v-if="percent > 0 || !hiddenTimer">
                <f7-gauge
                    :size="size"
                    :border-width="borderWidth"
                    border-bg-color="#D9D9D9"
                    :value-text="percent < 0 ? '0:00' : timeText"
                    type="circle"
                    :value="percent"
                    :value-font-size="fontSize"
                    value-font-weight="600"
                    :class="{'gauge_expired': percent <= 0}"
                    :border-color="borderColor"
                    :value-text-color="textColor"
                ></f7-gauge>
            </template>
            <template v-else>
                <div class="status-image"></div>
            </template>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";

defineProps({
    hiddenTimer: {
        type: [Boolean] as PropType<boolean>,
        default: true
    },
    borderColor: {
        type: [String] as PropType<string>,
        default: "#1890FF"
    },
    textColor: {
        type: [String] as PropType<string>,
        default: "#1890FF"
    },
    fontSize: {
        type: [Number] as PropType<number>,
        required: true
    },
    size: {
        type: [Number] as PropType<number>,
        required: true
    },
    borderWidth: {
        type: [Number] as PropType<number>,
        required: true
    },
    timeText: {
        type: [String, null] as PropType<string | null>,
        required: true
    },
    percent: {
        type: [Number] as PropType<number>,
        required: true
    }
});
</script>

<style lang="scss">
.payment__status-timer {
    .gauge {
        display: flex;
        &.gauge_expired {
            .gauge-value-text {
                fill: var(--red);
            }
        }
    }
}
</style>
